import React from 'react';
import { youtubeEmbedSrc } from '../../lib/youtube';

const VideoEmbed: React.FC<{ url: string; title?: string; className?: string }> = ({ url, title, className }) => {
  const src = youtubeEmbedSrc(url);
  if (src) {
    return (
      <div className={className} style={{ position: 'relative', aspectRatio: '16/9', borderRadius: 10, overflow: 'hidden', background: '#111' }}>
        <iframe
          src={src}
          title={title || 'Video'}
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
        />
      </div>
    );
  }
  // Direct video file — native player
  if (/\.(mp4|webm|mov)(\?|$)/i.test(url)) {
    return (
      <video src={url} controls playsInline preload="metadata" className={className} style={{ width: '100%', borderRadius: 10, background: '#111' }} />
    );
  }
  return (
    <a href={url} target="_blank" rel="noreferrer" className="text-fit-text-secondary hover:text-white text-[13px] underline underline-offset-2">
      Watch demo →
    </a>
  );
};

export default VideoEmbed;
